export default "__VITE_ASSET__9672ba6d__"